import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { PageMeta } from "../app/PageMeta";
import { ButtonLink } from "../components/ui/ButtonLink";
import { games } from "../content/siteContent";
import { useAppStore } from "../store/useAppStore";

export function GamePage() {
  const { slug = "" } = useParams();
  const game = games.find((entry) => entry.slug === slug);
  const setExperienceMode = useAppStore((state) => state.setExperienceMode);
  const setActiveGameSlug = useAppStore((state) => state.setActiveGameSlug);

  useEffect(() => {
    if (!game) {
      return;
    }

    setExperienceMode("detail");
    setActiveGameSlug(game.slug);

    return () => {
      setActiveGameSlug(null);
      setExperienceMode("home");
    };
  }, [game, setActiveGameSlug, setExperienceMode]);

  if (!game) {
    return <Navigate replace to="/" />;
  }

  return (
    <>
      <PageMeta description={game.description} path={`/games/${game.slug}`} title={`7 Stones | ${game.title}`} />

      <section className="detail-shell">
        <div className="detail-panel">
          <p className="section-panel__eyebrow">Game route</p>
          <h1 className="section-panel__display section-panel__display--detail">{game.title}</h1>
          <p className="section-panel__lead">{game.strapline}</p>
          <p className="section-panel__body">{game.description}</p>
          <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <ButtonLink to="/#contact">Plan the rollout</ButtonLink>
            <ButtonLink to="/#about" variant="ghost">
              Review studio approach
            </ButtonLink>
          </div>
        </div>

        <div className="detail-panel detail-panel--compact">
          <div className="projects-summary__metrics">
            {game.metrics.map((metric) => (
              <article className="projects-summary__metric" key={metric.label}>
                <span>{metric.label}</span>
                <strong>{metric.value}</strong>
              </article>
            ))}
          </div>

          <div className="info-grid info-grid--detail">
            {game.features.map((feature) => (
              <article className="info-card info-card--muted" key={feature}>
                <h3>{feature}</h3>
                <p>
                  Treat it as a route-level contract: the user can understand the game and act on the page without
                  waiting for a live WebGL render.
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
